import { render, staticRenderFns } from "./BusServermanageServiceList.vue?vue&type=template&id=03881604&scoped=true&"
import script from "./BusServermanageServiceList.vue?vue&type=script&lang=js&"
export * from "./BusServermanageServiceList.vue?vue&type=script&lang=js&"
import style0 from "./BusServermanageServiceList.vue?vue&type=style&index=0&id=03881604&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03881604",
  null
  
)

export default component.exports